var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.002 14.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#99b1c4;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Learn_More",
    "data-name": "Learn More"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.85,14.62,7.5,9.271l-5.35,5.351A1.261,1.261,0,0,1,.37,12.838l5.349-5.35L.37,2.137A1.26,1.26,0,0,1,2.152.356L7.5,5.706,12.851.356a1.261,1.261,0,0,1,1.784,1.781L9.283,7.489l5.35,5.35a1.261,1.261,0,0,1-1.784,1.784Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6977094fb43c299260614aca2ee9fc3e.svg";
export { ForwardRef as ReactComponent };